<div class="row h-full">
    <div class="col-12">
        <div class="google-maps">
            <input [id]="mapInputId" *ngIf="searchBox" class="map-search-box" />
            <google-map [height]="'100%'" [width]="'100%'" [center]="center" [zoom]="zoom" [options]="mapOptions" class="google-map-component">
                <map-marker [position]="center" *ngIf="center"></map-marker>
                <ng-container *ngFor="let location of locations;let i=index">
                    <map-marker [position]="location" (mapClick)="handleMapClickEvent($event, location.project)"
                        [title]="createTitleContent(location.project)" [icon]="showMarkers ? getMarkerIcon(i): ''"
                        ></map-marker>
                </ng-container>
            </google-map>
        </div>
    </div>
</div>